import { render, staticRenderFns } from "./ErrorPageLinkedPages.vue?vue&type=template&id=0ed3d012&"
import script from "./ErrorPageLinkedPages.vue?vue&type=script&lang=js&"
export * from "./ErrorPageLinkedPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports